import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {ItemModule} from "../../../../core/component/item/item.module";
import {SummaryFieldModule} from "../../../../core/component/summary-field/summary-field.module";
import {ProductSummaryFieldComponent} from "./product-summary-field.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ItemModule,
        SummaryFieldModule,
    ],
    declarations: [
        ProductSummaryFieldComponent,
    ],
    exports: [
        ProductSummaryFieldComponent
    ],
})
export class ProductSummaryFieldModule {
}
